<template>
  <div>
    <div style="margin-bottom: 16px;">
      <el-checkbox v-model="checked" label="发放奖励" size="large" />
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {updateZoneState} from '../../../api/url'
import {postFormData, getFormData} from "@/api/api";

export default {
  name: "SetQualityDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      loading: false,
      checked: true,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray;
      param['state'] = 1;
      param['awardState'] = this.checked?1:0;
      postFormData(updateZoneState, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },


  },
  created() {
  }
}
</script>

<style scoped>

</style>
